// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue5325(props) {
    return (
        <svg
            id="_x35_325"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#68836A;}\n\t.st1{font-family:'ArialMT';}\n\t.st2{font-size:11px;}\n\t.st3{fill:#5B5B5B;}\n\t.st4{fill:#7F7F7F;}\n\t.st5{fill:#FFEC5F;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n\t.st11{display:none;}\n\t.st12{display:inline;}\n\t.st13{font-size:4.995px;}\n\t.st14{fill:none;stroke:#B3B3B3;stroke-miterlimit:3.92;}\n\t.st15{fill:none;stroke:#B7B7B7;}\n"
                }
            </style>
            <g id="TEX">
                <g id="distances">
                    <text
                        id="right-field"
                        transform="matrix(1 0 0 1 224.0507 111.1338)"
                        className="st0 st1 st2"
                    >
                        326
                    </text>
                    <text
                        id="_x37_"
                        transform="matrix(1 0 0 1 172.9463 50.3672)"
                        className="st0 st1 st2"
                    >
                        374
                    </text>
                    <text
                        id="_x35_"
                        transform="matrix(1 0 0 1 147.9355 32.4043)"
                        className="st0 st1 st2"
                    >
                        410
                    </text>
                    <text
                        id="_x35__1_"
                        transform="matrix(1 0 0 1 85 32.4043)"
                        className="st0 st1 st2"
                    >
                        410
                    </text>
                    <text
                        id="center_1_"
                        transform="matrix(1 0 0 1 116.4678 31.4043)"
                        className="st0 st1 st2"
                    >
                        407
                    </text>
                    <text
                        id="_x33_"
                        transform="matrix(1 0 0 1 50.5732 53.7129)"
                        className="st0 st1 st2"
                    >
                        372
                    </text>
                    <text
                        id="left-field"
                        transform="matrix(1 0 0 1 5.861 107.4464)"
                        className="st0 st1 st2"
                    >
                        329
                    </text>
                </g>
                <g id="compass">
                    <path
                        className="st3"
                        d="M232.2,192.2l-3.9,8.3l-5.8,5.6l3.1-7.4L232.2,192.2z"
                    />
                    <path
                        className="st4"
                        d="M235.8,186.7c7,4.8,8.8,14.5,4,21.6s-14.5,8.8-21.6,4c-7-4.8-8.8-14.5-4-21.6 C219.1,183.7,228.7,181.9,235.8,186.7z M219,211.2c6.5,4.4,15.3,2.8,19.7-3.7c4.4-6.4,2.8-15.3-3.7-19.7 c-6.4-4.4-15.3-2.8-19.7,3.7C210.9,197.9,212.5,206.8,219,211.2z"
                    />
                    <path
                        className="st3"
                        d="M224.1,200.1c-0.3-1.6,0.8-3.2,2.4-3.5c1.6-0.3,3.2,0.8,3.5,2.4c0.3,1.6-0.8,3.2-2.4,3.5 C225.9,202.7,224.4,201.7,224.1,200.1z M222.8,207.8l-1.7,2.5l-0.4-0.3v-2.5l-1.2,1.8L219,209l1.7-2.5l0.4,0.3v2.6l1.2-1.8 L222.8,207.8z"
                    />
                    <path
                        className="st5"
                        d="M225.4,199.8c-0.2-0.9,0.4-1.8,1.3-1.9s1.8,0.4,1.9,1.3c0.2,0.9-0.4,1.8-1.3,1.9 C226.4,201.3,225.6,200.7,225.4,199.8z"
                    />
                </g>
                <g id="field">
                    <path
                        id="outfield_00000176019447424471975020000015478149771427856801_"
                        className="st6"
                        d="M27.8,110L56,138.6l6.9,22.9l8.5,12.1 l33.5,41.2c0,0,9.6,5.8,10.2,6s6.6,0.1,10.2,0.1c3,0,9.1,0.2,9.8,0s8.9-5.1,9.4-5.8c17.6-20.9,30.5-37.4,30.5-37.4l22.3-29.5 l3.9-14l-0.2-3.5l17.3-17.7l1.6-2l-0.2-2.5l-0.5-2.8l-0.6-2.9l-0.5-2.9l-0.6-3l-0.6-3.1l-1.1-2.6l-1.8-1.8l-1.8-1.8l-1.8-1.8 l-1.8-1.8l-1.8-1.8l-1.8-1.9l-1.9-1.8l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.9-1.9l-1.4-3l-2-2l-2-2l-2-2l-2-2l-2.1-2.1l-2.1-2.1 l-2.8-0.4l-3.1,0.5l-2.7-0.4l-2.2-2.2l-2.2-2.2l-2.2-2.2l-2.3-2.3l-2.4-2.4l-2.4-2.4l-2.5-2.5l-2.5-2.5l-2.5-2.6l-3-0.2h-3h-3h-3 h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3h-3l-2.8,1.4l-2.7,1.6l-2.7,1.6L93.5,40l-2.7,1.5L88.3,43l-2.6,1.5L83.1,46l-2.5,1.5L78.1,49 l-1.8,3.5l-2.2,2.3L71.7,56l-2.4,1.4l-2.4,1.4l-2.4,1.4l-2.4,1.3l-2.4,1.4l-2.3,1.3l-2.3,1.4l-2.3,1.3l-2.3,1.3l-2.3,1.4l-2.3,1.3 l-2.3,1.3l-2.3,1.3L38.8,75l-2.3,1.3l-2.3,1.5l-0.7,3.5l-0.7,3.5l-0.6,3.4l-0.7,3.2l-0.6,3.2l-0.6,3.1l-0.6,3l-0.6,2.9l-0.6,2.8 L27.8,110z"
                    />
                    <path
                        id="grass_00000090994939672626314830000016650827298536189595_"
                        className="st0"
                        d="M148.4,39.7l22.9,22.6l6.4-1.9l11.5,11.3 l0.3,1.5l4.7,5.1l17.1,16.1l2.4,14.4l-20,19.7l1.7,4.4c0,0-2.5,10.7-3.4,12.2s-7.2,8.7-8.1,10.1c0,0-13,17.5-15.7,20.8 c-2.7,3.2-11.6,15.6-13.4,17.6s-7.8,10.2-9.3,12.1s-9.1,8-11.9,9c-1.4,0.5-4.8,0.3-8.3,0.4c-3.5,0-7.1,0.3-8.7-0.4 c-3.2-1.3-7.5-3.8-11.7-9.1c0,0-10.4-13.2-14.5-18.8s-4.2-5.5-4.2-5.5s-15.3-19.2-18-22.5c-2.7-3.2-4.3-13-5.2-15.9 s-0.2-5.6-3.6-9.3C56,129.9,33.8,108,33.8,108s3-16.7,3.3-18s1.8-8.3,1.8-8.3l41.4-24.2l1.2-4.5l23.4-13.5h43.5V39.7z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7 c-0.5,0.9-0.7,1.9-0.7,3c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7c0-1.1-0.3-2.1-0.7-3L163.9,166.7z M122.5,154.7 c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5l-17.7,17.7c-1.2-1-2.7-1.6-4.3-1.6 s-3.2,0.6-4.3,1.6l-17.7-17.7l2.5-2.5c1.6-1.5,1.6-4,0-5.6L122.5,154.7z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l-97-97"
                        />
                        <path
                            id="right-foul-line_2_"
                            className="st8"
                            d="M125.2,203.2l94.4-94.5"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st11">
                <g className="st12">
                    <g id="numbers">
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 90.9866 184.0761)"
                            className="st1 st13"
                        >
                            90
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 56.4654 153.8222)"
                            className="st1 st13"
                        >
                            200
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 71.0452 168.4018)"
                            className="st1 st13"
                        >
                            150
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 80.378 177.7343)"
                            className="st1 st13"
                        >
                            120
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 41.6028 138.9599)"
                            className="st1 st13"
                        >
                            250
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 27.4712 123.956)"
                            className="st1 st13"
                        >
                            300
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 12.6905 109.1753)"
                            className="st1 st13"
                        >
                            350
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 75.9258)"
                            className="st1 st13"
                        >
                            400
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 49.4311)"
                            className="st1 st13"
                        >
                            450
                        </text>
                        <text
                            transform="matrix(0.7175 -0.6966 0.6966 0.7175 15.0056 24.6201)"
                            className="st1 st13"
                        >
                            500
                        </text>
                    </g>
                    <g id="surface29_2_">
                        <path className="st14" d="M125.5,203.8l-148-148" />
                        <path className="st14" d="M124.8,203.8l148-148" />
                        <path className="st15" d="M125.1,203.5L45.4,10.9" />
                        <path className="st15" d="M125.1,203.5V-4.9" />
                        <path className="st15" d="M125.1,203.5l79.8-192.6" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st14"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line_2_"
                        className="st14"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5c23,0,43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line_2_"
                        className="st14"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1c10.4,0,19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st14"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4c17.2,0,32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st14"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6c28.7,0,54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st14"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st14"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1c40.2,0,76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st14"
                        d="M-7.4,70.9c33.9-34,80.8-55,132.6-55c51.7,0,98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line_1_"
                        className="st14"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9c46,0,87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st14"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9c57.5,0,109.5,23.3,147.2,61"
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue5325
